<script lang="ts">
  import type { BuilderTilesContent } from '../data';

  import { fade } from 'svelte/transition';

  import { Accordion, AccordionItem, Layout, ScrollTiles, Typography } from './components';
  import { useContent } from './contexts';

  const content = useContent();

  function byCategory(builderTiles: BuilderTilesContent, category: string) {
    return builderTiles.filter((item) => item.category === category);
  }
</script>

<Layout>
  <section slot="content" class="start-wrapper">
    <div in:fade class="start-heading-container">
      <Typography type="h1" centred={false} condensed display size={2} end={1}>Jewellery Builder</Typography>
      <Typography type="h2" centred={false} end={0.75}>Choose a piece you want to custom-create</Typography>
    </div>
    <div in:fade class="start-accordion-container">
      {#await content.builderTiles()}
        <Accordion>
          <AccordionItem title="Rings" />
          <AccordionItem title="Earrings" />
          <AccordionItem title="Chains" />
        </Accordion>
      {:then builderTiles}
        <Accordion>
          <AccordionItem title="Rings" open>
            <ScrollTiles tiles={byCategory(builderTiles, 'Rings')} />
          </AccordionItem>
          <AccordionItem title="Earrings">
            <ScrollTiles tiles={byCategory(builderTiles, 'Earrings')} />
          </AccordionItem>
          <AccordionItem title="Chains">
            <ScrollTiles tiles={byCategory(builderTiles, 'Chains')} />
          </AccordionItem>
        </Accordion>
      {/await}
    </div>
  </section>
</Layout>

<style>
  .start-wrapper {
    background: var(--layer);
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .start-heading-container {
    padding-block-start: var(--layout-panel-height-mobile);
    height: var(--start-heading-height);
    margin-inline: 2rem;

    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .start-accordion-container {
    height: var(--accordion-height);
  }
</style>
